import {Championships, GimmickMatches, Messages, Superstars} from "./models.js";

function RandomEvent() {

    // Integer
    const monthsRemaining = null;

    // Strings
    const name = null;
    const selectedChoice = null;
    const location = null;

    // Arrays
    const choices = [];
    const eventsRun = [];
    const selectionIds = [];

    // Foreign keys
    const companyId = null;
    const superstarId = null;
    const championshipId = null;
    const gimmickMatchId = null;

    return {
        monthsRemaining,
        name,
        selectedChoice,
        location,
        choices,
        eventsRun,
        selectionIds,
        companyId,
        superstarId,
        championshipId,
        gimmickMatchId,
    };
}

function addRandomEventMessages(randomEvent, messages) {
    messages.forEach(c => {
        c.randomEventId = randomEvent.$loki
    });
}

function removeRandomEventMessages(randomEvent, messages) {
    messages.forEach(c => {
        c.randomEventId = null
    });
}

function getRandomEventMessage(randomEvent) {
    return Messages.find({'randomEventId': randomEvent.$loki})[0];
}

function getRandomEventSuperstar(randomEvent) {
    return Superstars.find({'$loki': randomEvent.superstarId})[0];
}

function getRandomEventChampionship(randomEvent) {
    return Championships.find({'$loki': randomEvent.championshipId})[0];
}

function getRandomEventGimmickMatch(randomEvent) {
    return GimmickMatches.find({'$loki': randomEvent.gimmickMatchId})[0];
}

export { RandomEvent, addRandomEventMessages, removeRandomEventMessages, getRandomEventMessage, getRandomEventSuperstar,
    getRandomEventChampionship, getRandomEventGimmickMatch }
